import { Actions, createEffect, FunctionalEffect, ofType } from '@ngrx/effects';
import { inject } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { getUserMe, userMeError, getUserMeSuccess } from '@app/main/user-me/store/user-me/user-me.actions';
import { UserMeApiService } from '@app/api/services/user-me-api.service';
import { of } from 'rxjs';
import { PermissionsService } from '@app/core/permissions/services/permissions.service';

export const getUser$: FunctionalEffect = createEffect(
  (
    actions$ = inject(Actions),
    userApiService = inject(UserMeApiService),
    permissionsService = inject(PermissionsService)
  ) => {
    return actions$.pipe(
      ofType(getUserMe),
      switchMap(() =>
        userApiService.get().pipe(
          map(({ data }) => {
            permissionsService.initUserPermissions(data);

            return getUserMeSuccess({ data });
          }),
          catchError(error => of(userMeError(error)))
        )
      )
    );
  },
  { functional: true }
);
